<template>
  <div class="goTop-group">
    <div class="goTop" @click="goTop"></div>
    <div class="mobile-goTop" @click="goTop"></div>
  </div>
</template>

<script>
export default {
  name: "GoTop",
  props: ["data"],
  data() {
    return {};
  },
  methods: {
    goTop: function() {
      this.$("body,html").animate({
        scrollTop: 0
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.goTop-group {
  .goTop {
    position: fixed;
    width: 80px;
    height: 80px;
    bottom: 100px;
    right: 20px;
    background: url("../assets/images/gotop/goTop.png") no-repeat center center / cover;
    cursor: pointer;
    z-index: 1;
  }
  .mobile-goTop {
    position: fixed;
    width: 5rem;
    height: 5rem;
    bottom: 4rem;
    right: 2rem;
    background: url("../assets/images/gotop/goTop.png") no-repeat center center / cover;
    cursor: pointer;
    z-index: 100;
    display: none;
  }
}
@media (max-width: 1024px) {
  .goTop {
    display: none !important;
  }
  .mobile-goTop { 
    display: block !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue